import optimizeSingleAttribute from "../../../utils/process-dataset/optimize-single-attribute";
import runAction from "../../actions/run-action";
import setParentStyle from "../../store/utils/set-parent-style";

/**
 * Check if variable contains a "get" actions
 * @param {String} find
 * @param {MainClassProps} main
 * @returns {String}
 */
const checkVariableAction = (find, main) => {
  const isAction = /^get\(/.test(find);

  /** Is `get` action */
  if (isAction) {
    const parent = optimizeSingleAttribute(find);
    const trigger = new Map();
    const step = /** @type {StepProps} */ (
      new Map([["properties", new Map()]])
    );

    const result = /** @type {Map<string, any>} */ (
      setParentStyle(parent, trigger, step, null)
    );

    for (const action of result.get("get").values()) {
      return /** @type {String} */ (runAction(action, main, action)) || "";
    }
  }

  return find;
};

export default checkVariableAction;
